var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8714 1.54443L10.7805 2.63534M10.7805 2.63534L12.4169 4.27171L10.5078 6.1808L8.87142 4.54443M10.7805 2.63534L8.87142 4.54443M6.6296 6.78625C6.91124 7.06414 7.13513 7.395 7.28838 7.75977C7.44162 8.12455 7.5212 8.51603 7.52253 8.91169C7.52385 9.30734 7.4469 9.69935 7.2961 10.0651C7.1453 10.4309 6.92364 10.7633 6.64386 11.0431C6.36409 11.3228 6.03174 11.5445 5.66595 11.6953C5.30016 11.8461 4.90815 11.923 4.51249 11.9217C4.11684 11.9204 3.72535 11.8408 3.36058 11.6876C2.99581 11.5343 2.66495 11.3104 2.38706 11.0288C1.84058 10.463 1.5382 9.70518 1.54504 8.91859C1.55187 8.132 1.86738 7.37957 2.4236 6.82334C2.97983 6.26712 3.73226 5.95161 4.51885 5.94478C5.30544 5.93794 6.06325 6.24032 6.62906 6.7868L6.6296 6.78625ZM6.6296 6.78625L8.87142 4.54443",
    stroke: "#1E6052",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.d723de411741c4cce5a49a7040e4aa97.svg";
export { ForwardRef as ReactComponent };